import { BiteLogAdyenEvent } from './bite_log_adyen_event.js';

export function name(event: BiteLogAdyenEvent): string {
  switch (event) {
    case BiteLogAdyenEvent.TerminalDisconnected:
      return 'terminal-disconnected';
  }
}
